import { shape, string, number } from 'prop-types';

export default shape({
  _id: string.isRequired,
  phone: string.phone,
  role: number.isRequired,
  lastSeen: number,
});
